export default __webpack_public_path__ + "static/media/ICSE Chemistry.e4851adf.pdf";